import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-demo-form-dialog',
  templateUrl: './demo-form-dialog.component.html',
  styleUrls: ['./demo-form-dialog.component.scss']
})
export class DemoFormDialogComponent {
  formId: string;

  constructor(
    private dialogRef: MatDialogRef<DemoFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data)
  {
    this.formId = data.formId;
  }

  close(){
    this.dialogRef.close();
  }
}
